import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'ml-confirm-dialog',
  template: `
    <div class="confirm-dialog" fxLayout="column" fxLayoutAlign="space-between">
      <div class="mat-title">
        {{ data.title | translate | sentancecase }}
      </div>

      <mat-form-field>
        <mat-label> {{ data.inputLabel | translate | sentancecase }}</mat-label>
        <input matInput [formControl]="inputControl" />
      </mat-form-field>

      <ml-dialog-actions
        [disable]="inputControl.invalid"
        (clickLeft)="onCancel()"
        (clickRight)="onSubmit()"
      ></ml-dialog-actions>
    </div>
  `,
  styleUrls: ['./prompt-dialog.component.scss']
})
export class PromptDialogComponent implements OnInit {
  inputControl = new FormControl('', Validators.required);

  constructor(
    private dialogRef: MatDialogRef<PromptDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string;
      inputLabel: string;
    }
  ) {}

  ngOnInit() {}

  onCancel() {
    this.dialogRef.close();
  }

  onSubmit() {
    this.dialogRef.close(this.inputControl.value);
  }
}
